import type { MouseEvent } from 'react';
import type { UIPaymentGroups } from 'store/formatters';
import { setSelectedPayGroupId } from 'store/slices/global';

import { selectDepositMethodHandler } from '../../Deposit/utils';
import type { AbstractCarouselSelectStrategy } from './AbstractCarouselSelectStrategy';
import type { CarouselSelectStrategyHandlerProps } from './models';

export class CarouselDepositSelectStrategy implements AbstractCarouselSelectStrategy {
  public handle(props: CarouselSelectStrategyHandlerProps, e: MouseEvent): void {
    const { method, platform, dispatch, navigate, flowType, currentPayGroupId } = props;

    selectDepositMethodHandler(
      {
        method: method as UIPaymentGroups,
        platform,
        dispatch,
        navigate,
        flowType,
        currentPayGroupId,
      },
      e,
    );

    dispatch(setSelectedPayGroupId(method.id));
  }
}
